import {
  CPSConfig,
  CPSConfigFunctionnality,
  IProduct,
  IProductFunctionnality,
  OTAUpdateProperty,
  ProductTuto,
} from '../IProduct';
import { P00039DataRxTxIndex } from './P00039Sync';
import { P0003604FunctionFinish } from './P0003604/Installation/P0003604InstallationFinish';
import { P0003604FunctionReset } from './P0003604/Installation/P0003604InstallationReset';
import { Pool } from '../../../../apis/pool.api';
import { EventProductFunctionnalityEnum } from '../../../../apis/poolEvent.api';
import { environment } from '../../../../../environments/environment';
import { FunctionParametersProductComponent } from '../../../../components/ecosystems/function-parameters-product/function-parameters-product.component';
import { P0003604BlowerMiseEnOeuvreInit } from './P0003604/Blower/miseenoeuvre/P0003604BlowerMiseEnOeuvreInit';

export class P0003604Data {
  blCConfirmationOTA: number = 0;

  blCResetProtectionMagnetique: number = 0;

  blCResetProtectionThermique: number = 0;

  blCResetUsine: number = 0;

  blCCommandePompe: number = 0;

  blPDureeTemporisation: number = 0;

  blIConfigurationProduit: number = 0;

  blIActivationProtectionThermique: number = 0;

  blIActivationProtectionMagnetique: number = 0;

  blICourantNominalPompe: number = 0;

  blSAlarme: number = 0;

  blSCommandePompe: number = 0;

  blSEtatPompe: number = 0;

  blSEtatProtectionMagnetique: number = 0;

  blSEtatProtectionThermique: number = 0;

  blSEtatBouton: number = 0;

  blSCompteARebours: number = 0;

  blSCourantConsommePompe: number = 0;

  blSNombreCommutationRelais: number = 0;

  blSTensionSecteur: number = 0;

  blSPuissanceApparente: number = 0;

  blSPuissanceActive: number = 0;

  blSCompteurPuissanceApparenteTotale: number = 0;

  blSCompteurPuissanceActiveTotale: number = 0;

  blSCompteurAmpereHeure: number = 0;

  blSTempsSousTension: number = 0;

  blSCompteurBouton: number = 0;

  blSCompteurResetUsine: number = 0;

  blSCompteurResetManuelProtectionMagnetique = 0;

  blSCompteurResetManuelProtectionThermique = 0;
}

export class P0003604 extends IProduct {
  override deviceTableIndex: number = 22;

  override modelIdentifier?: string = 'P00036-04';

  override dataIdentifier?: string = 'P0003604';

  override manufacturerName?: string = 'ACWA';

  data: P0003604Data = new P0003604Data();

  getProductSmallIllustration(): any {
    return '/assets/ecosystem/images/products/P0003604/smallProduct.png';
  }

  getProductIllustration(): any {
    return '/assets/ecosystem/images/products/P0003604/product.png';
  }

  getProductImage(): any {
    return '/assets/ecosystem/images/products/P0003604/product.png';
  }

  getProductKey(): string {
    return this.modelIdentifier!;
  }

  getProductDeviceTableFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.master?.deviceTable?.P0003604;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductDataFromPool(pool: Pool): any {
    const res = pool?.deviceTable?.P0003604?.data;

    if (res != undefined && res != null) {
      return res;
    }

    return null;
  }

  getProductTuto(): ProductTuto {
    return {
      hasHelp: true,
      helpTitle: 'P0003604.tuto.installation.help.title',
      helpSlides: [
        'P0003604.tuto.installation.help.1',
        'P0003604.tuto.installation.help.2',
        'P0003604.tuto.installation.help.3',
        'P0003604.tuto.installation.help.4',
      ],
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003604/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003604/installation-1_dark.png',
          },
          text: 'P0003604.tuto.installation.page1',
        },
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003604/installation-2.png',
            dark: '/assets/ecosystem/images/products/P0003604/installation-2_dark.png',
          },
          text: 'P0003604.tuto.installation.page2',
        },
      ],
    };
  }

  getUpdateTuto(): ProductTuto {
    return {
      slides: [
        {
          image: {
            light:
              '/assets/ecosystem/images/products/P0003604/installation-1.png',
            dark: '/assets/ecosystem/images/products/P0003604/installation-1_dark.png',
          },
          text: 'P0003604.tuto.update.page1',
        },
        {
          image: {
            light: '/assets/ecosystem/images/products/P0003604/update-2.png',
            dark: '/assets/ecosystem/images/products/P0003604/update-2_dark.png',
          },
          text: 'P0003604.tuto.update.page2',
        },
      ],
    };
  }

  getCPSConfig(): CPSConfig | null {
    return {
      installation: {
        pages: [
          /*{
            component: P0003604InstallationSurpresseur, condition: () => {
              return true;
            },
          },*/
        ],
        finish: P0003604FunctionFinish,
        reset: P0003604FunctionReset,
      },
      controlCards: [
        //{ component: P0003604CardBlowerControle, weight: 10 },
      ],

      statusCards: [
        //{ component: P0003604CardBlowerStatut, weight: 28 },
      ],

      parametrages: {
        enabledUser: false,
        enabledSupport: false,

        general: {
          enabledUser: true,
          enabledSupport: true,
          component: FunctionParametersProductComponent,
        },
      },
    };
  }

  getEventProductFunctionalities(): EventProductFunctionnalityEnum[] {
    return [EventProductFunctionnalityEnum.BLOWER];
  }

  getCPSConfigByFonctionnality(
    functionnality: IProductFunctionnality,
  ): CPSConfigFunctionnality | null {
    if (functionnality == IProductFunctionnality.BLOWER) {
      return {
        miseEnOeuvre: {
          pages: [
            //{ component : P0003604BlowerMiseEnOeuvreTemporisation, condition: () => { return true; } },
          ],
          init: P0003604BlowerMiseEnOeuvreInit,
        },

        controle: {
          enabledUser: true,
          enabledSupport: true,

          //component: P0003604BlowerControle,
        },
        parametrages: {
          enabledUser: true,
          enabledSupport: true,

          reglage: {
            enabledUser: true,
            enabledSupport: true,
            //component: P0003604BlowerParameters,
          },
        },
        status: {
          enabledUser: true,
          enabledSupport: true,
          //component: P0003604BlowerStatut,
        },
        historique: {
          enabledUser: true,
          enabledSupport: true,

          suivi: {
            enabledUser: true,
            enabledSupport: true,
            //component: P0003604BlowerHistoriqueSuivi,
          },
        },
      };
    }
    return null;
  }

  getPropertyForOTAUpdate(): OTAUpdateProperty | null {
    return {
      index: P00039DataRxTxIndex.Blower_Controle,
      propertyName: 'blCConfirmationOTA',
    };
  }

  getMinimumFirmwareVersionForBleUpdate(): number | null {
    return 16;
  }

  needConfiguration(pool: Pool): boolean {
    return this.getProductDataFromPool(pool).blIConfigurationProduit !== 1;
  }

  getProductVideoURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.mp4'
    );
  }

  getProductVideoChapterURI(langCode: string): string | null {
    return (
      environment.videoBaseUri +
      this.modelIdentifier +
      '_' +
      langCode +
      '_2.csv'
    );
  }
}
